import './index.scss';
import { DateTime } from 'luxon';
import React from 'react';
import { Link } from 'react-router-dom';
import { MetadataFieldNames } from '~/types/common';
import { ColumnName } from '.';
const columnDef = () => {
    return [
        {
            field: ColumnName.Checkbox,
            headerName: '',
            checkboxSelection: true,
            suppressSizeToFit: true,
            width: 5,
            hide: true,
        },
        {
            field: ColumnName.Date,
            headerName: 'DATE',
            headerTooltip: 'DATE',
            maxWidth: 200,
            valueGetter: (parm) => {
                return parm.data.timestamp
                    ? DateTime.fromISO(`${parm.data.timestamp}Z`).toFormat('LLL d, yyyy, t')
                    : '';
            },
            cellRenderer: (props) => (React.createElement("span", { title: props.value }, props.value)),
        },
        {
            field: ColumnName.DocumentName,
            headerName: 'DOCUMENT NAME',
            headerTooltip: 'DOCUMENT NAME',
            flex: 1,
            cellRenderer: (props) => {
                var _a;
                return React.createElement(Link, { title: props.value, target: '_blank', to: {
                        pathname: `/document/${(_a = props.data) === null || _a === void 0 ? void 0 : _a.fileId}`,
                    } }, props.value);
            },
        },
        {
            field: ColumnName.FormName,
            headerName: 'FORM NAME',
            headerTooltip: 'FORM NAME',
            flex: 1.5,
            cellRenderer: (props) => {
                var _a, _b;
                const metadata = (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.metadata.find(m => m.name === MetadataFieldNames.filename)) === null || _b === void 0 ? void 0 : _b.value;
                const formName = typeof metadata === 'string' ? metadata : '';
                return React.createElement("span", { title: formName }, formName);
            },
        },
        {
            field: ColumnName.FormNumber,
            headerName: 'FORM NUMBER',
            headerTooltip: 'FORM NUMBER',
            width: 200,
            maxWidth: 250,
            cellRenderer: (props) => {
                var _a, _b;
                const metadata = (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.metadata.find(m => m.name === MetadataFieldNames.formNumber)) === null || _b === void 0 ? void 0 : _b.value;
                const formNumber = typeof metadata === 'string' ? metadata : '';
                return React.createElement("span", { title: formNumber }, formNumber);
            },
        },
    ];
};
export default columnDef;
